/**
 * Build query params for GET /contacts/ list.
 * Param names match OpenAPI: stage_ids, sources, tags, from_date, to_date, etc.
 */
export function buildCRMContactsListParams({
  search,
  stageId,
  source,
  tag,
  dateFrom,
  dateTo,
  valueMin,
  valueMax,
  consentStatus,
  assignedEmployeeId,
  flowId,
  customFieldSlug,
  customFieldValue,
} = {}) {
  const params = {};

  if (search) params.search = search;
  if (stageId) params.stage_ids = String(stageId);
  if (source) params.sources = source;
  if (tag) params.tags = tag;
  if (dateFrom) params.from_date = dateFrom;
  if (dateTo) params.to_date = dateTo;
  if (valueMin !== '' && valueMin != null) {
    params.min_estimated_value = valueMin;
  }
  if (valueMax !== '' && valueMax != null) {
    params.max_estimated_value = valueMax;
  }
  if (consentStatus) params.consent_status = consentStatus;
  if (assignedEmployeeId) {
    params.assigned_to_employee_id = Number(assignedEmployeeId);
  }
  if (flowId) {
    params.flow_id = !isNaN(Number(flowId)) ? Number(flowId) : flowId;
  }
  if (customFieldSlug && customFieldValue !== '' && customFieldValue != null) {
    params.custom_fields = JSON.stringify({
      [customFieldSlug]: customFieldValue,
    });
  }

  return params;
}

/**
 * Map list filter params into export `filter_params`.
 * Export schema uses some aliases (assigned_to, source_type, tag_ids).
 * List-only keys (stage_ids, dates, estimated value) are kept so backend
 * can apply the same filtered set when supported.
 */
export function buildCRMContactsExportFilterParams(
  listParams = {},
  { tagIdByName = {} } = {},
) {
  const filter = { ...listParams };

  if (filter.assigned_to_employee_id != null && filter.assigned_to == null) {
    filter.assigned_to = Number(filter.assigned_to_employee_id);
  }

  if (filter.sources && !filter.source_type) {
    filter.source_type = filter.sources;
  }

  if (filter.tags && !filter.tag_ids) {
    const tagId = tagIdByName[filter.tags];
    if (tagId != null) {
      filter.tag_ids = [Number(tagId)];
    }
  }

  if (typeof filter.custom_fields === 'string') {
    try {
      filter.custom_fields = JSON.parse(filter.custom_fields);
    } catch {
      // keep string if not valid JSON
    }
  }

  return filter;
}
